import { render, staticRenderFns } from "./addRemindersEmailSchedule.vue?vue&type=template&id=457ac607&scoped=true"
import script from "./addRemindersEmailSchedule.vue?vue&type=script&lang=js"
export * from "./addRemindersEmailSchedule.vue?vue&type=script&lang=js"
import style0 from "./addRemindersEmailSchedule.vue?vue&type=style&index=0&id=457ac607&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "457ac607",
  null
  
)

export default component.exports